import axios from 'axios';

export function getAllInvoices() {
	return axios.get(`/settings/account/billing/invoices`);
}
